export default __webpack_public_path__ + "static/media/spinner.f2e392a7.svg";